import Vue from 'vue'
import { Dialog, Input, Button, Message, Scrollbar, Loading, Image, Row, Col } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

;[Dialog, Input, Button, Scrollbar, Loading, Image, Row, Col].forEach((e) => Vue.use(e))
Vue.prototype.$message = Message
